export default __webpack_public_path__ + "static/media/UBCVillageMedicalBG.40613cec.jpg";